import $ from 'jquery';
import cart from '@wc-stripe/cart';
import AbstractMessage from './AbstractMessage';

class CheckoutMessage extends AbstractMessage {

    /**
     * Per-gateway elements used in 'payment_method_title' mode.
     * Each entry is {element, paymentMethod}.
     *
     * @type {Array<{element: Object, paymentMethod: {id: string, paymentMethodType: string}}>}
     */
    titleElements = [];

    initialize() {
        this.loadStripeSDK().then(() => {
            if (this.location === 'payment_method_title') {
                this.createTitleElements();
                this.mountTitleElements();
            } else {
                this.createMessageElement();
                if (this.hasPaymentMethodTypes()) {
                    this.mountElement();
                }
            }
            this.initActions();
        });
    }

    initActions() {
        this.actions.addAction('updated_checkout', this.onUpdatedCheckout.bind(this));
    }

    showMessageElement() {
        $('.wc-stripe-bnpl-checkout-message').show();
    }

    onUpdatedCheckout() {
        if (!this.isSupported()) {
            this.unmountElement();
            return;
        }
        if (this.location === 'payment_method_title') {
            if (!this.titleElements.length) {
                this.createTitleElements();
            }
            for (const entry of this.titleElements) {
                entry.element.update(this.buildTitleElementOptions(entry.paymentMethod));
            }
            this.mountTitleElements();
        } else {
            if (!this.messageElement) {
                this.createMessageElement();
            } else {
                this.updateElement();
            }
            if (this.hasPaymentMethodTypes()) {
                this.mountElement();
            } else {
                this.unmountElement();
            }
        }
    }

    getTotalCents() {
        return cart.getTotalCents();
    }

    getCurrency() {
        return cart.getCurrency();
    }

    getCountryCode() {
        return $('#billing_country').val() || $('#shipping_country').val() || super.getCountryCode();
    }

    getPaymentMethodTypes() {
        const paymentMethodTypes = [];
        for (const paymentMethod of this.paymentMethods) {
            if (this.location === 'payment_method_title') {
                if (cart.isPaymentMethodAvailable(paymentMethod.id)) {
                    paymentMethodTypes.push(paymentMethod.paymentMethodType);
                }
            } else {
                paymentMethodTypes.push(paymentMethod.paymentMethodType);
            }
        }
        return paymentMethodTypes;
    }

    // -------------------------------------------------------------------------
    // Payment method title mode — one element per gateway
    // -------------------------------------------------------------------------

    createTitleElements() {
        if (!this.isSupported()) {
            return;
        }
        for (const pm of this.paymentMethods) {
            const options = this.buildTitleElementOptions(pm);
            const element = this.elements.create(this.elementType, options);
            this.titleElements.push({element, paymentMethod: pm});
        }
    }

    buildTitleElementOptions(paymentMethod) {
        return this.actions.applyFilters('get_message_element_options', {
            amount: this.getTotalCents(),
            currency: this.getCurrency(),
            paymentMethodTypes: [paymentMethod.paymentMethodType],
            countryCode: this.getCountryCode()
        }, this);
    }

    mountTitleElements() {
        for (const {element, paymentMethod} of this.titleElements) {
            // When rendering to the payment method title, make sure the payment method is available
            if (cart.isPaymentMethodAvailable(paymentMethod.id)) {
                const container = this.getTitleContainer(paymentMethod.id);
                if (container && !container.children.length) {
                    element.mount(container);
                }
            }
        }
    }

    getTitleContainer(gatewayId) {
        const id = `wc-${gatewayId}-bnpl-checkout-msg`;
        let el = document.getElementById(id);
        if (!el) {
            el = document.createElement('span');
            el.id = id;
            el.className = 'wc-stripe-bnpl-checkout-message';
            const label = document.querySelector(`label[for="payment_method_${gatewayId}"]`);
            if (label) {
                label.appendChild(el);
            }
        }
        return el;
    }

    getElementContainer() {
        let el = super.getElementContainer();
        if (!el) {
            const id = this.selector.replace('#', '');
            const tr = document.createElement('tr');
            tr.className = 'wc-stripe-bnpl-checkout-message';
            tr.innerHTML = `<td colspan="2"><div id="${id}"></div></td>`;
            const anchor = document.querySelector('.woocommerce-checkout-review-order-table .order-total');
            if (anchor) {
                anchor.after(tr);
            }
            el = document.getElementById(id);
        }
        return el;
    }
}

export default CheckoutMessage;